import random from 'toxilibs/random.js'
import Level from '../core/level.js'
import mathText from '../math_text.js'

const level = new Level({
    name: 'vector_length',
    dependencies: [
        'levels_maths/vector',
        'levels_maths/distance_to_origin'
    ]
})



level.addQuestion({
    generator: function (q) {
        let b = {
            x: random.fairChoiceInt(1, 5, {name: 'x'}),
            y: random.fairChoiceInt(1, 5, {name: 'y'}),
            name: 'B'
        }

        let geoScreen = q.addGeoScreen({
            noAxes: true
        })

        let a = {
            x: 0,
            y: 0,
            name: 'A',
            color: '#F00'
        }

        geoScreen.addVectorWithPoints({
            start: a,
            end: b
        })


        q.addText(mathText.vector({name: 'AB', x: b.x, y: b.y, color: '#F00'}))
        q.addText(mathText.pointsDistance(a, b) + ' ?')
        q.answer = [
            'racine(' + (b.x * b.x + b.y * b.y) + ')',
            q.approximation(Math.sqrt(b.x * b.x + b.y * b.y), 0.1)
        ]
    },
    times: 2
})


export default level

